{
  "title": "Usuarios",
  "user": "usuario",
  "firstName": "Nombre",
  "lastName": "Apellido",
  "middleName": "Segundo Nombre",
  "email": "Correo Electronico",
  "homeNumber": "Telefono Hogar",
  "mobileNumber": "Telefono Celular",
  "role": "Rol",
  "users-create-title": "Crear Usuario",
  "created": "Usuario creado",
  "add-user": "Agregar Usuario",
  "create-user-description": "Para crear a un nuevo usuario, complete la siguiente información. Enviaremos una invitación para esta persona.",
  "invite-user-description": "Para invitar a un nuevo usuario a este pedido, complete la siguiente información. Enviaremos una invitación para esta persona.",
  "send-invitation": "Mandar invitacion",
  "invite-user": "Invitar Usuario",
  "add-party": "invitar Parte",
  "personal-info": "Información Personal",
  "contact-information": "Información de contacto",
  "delete-user": "Eliminar usuario",
  "are-you-delete": "Estas seguro que quieres ",
  "delete": "Borrar",
  "this-person": "a esta persona?",
  "once-you-delete": "Una vez que tu borres este usuario, no volvera. Asegurate que quieres esto.",
  "yes-delete-it": "Si, Borralo",
  "confirm-by-tipping": "Confirma escribiendo",
  "sending-invite": "enviando invitacion…",
  "updating-user": "actualizando usuario...",
  "getting-user": "obteniendo usuario...",
  "user-opened-orders": "Ordenes Abiertas",
  "see-all-orders": "Ver Todas",
  "agent-job": "Trabajo de agente",
  "void-licenses": "No hay licencias todavia",
  "marketer": "Comercialzador",
  "legal": "Legal",
  "escrow_officer": "Oficial de Custodia",
  "funder": "Financiador",
  "assistant": "Assistente",
  "accounting": "Contabilidad",
  "policy_production": "Producción de políticas",
  "gender": "Genero",
  "marital-status": "Estado civil",
  "date-of-birth": "Fecha de Nacimiento",
  "work-number": "Numero del trabajo",
  "profile": "Perfil",
  "log-out": "Cerrar sesión",
  "examiner": "Examinador",
  "general-information": "Información General",
  "personal-information": "Información Personal",
  "addresses": "Direcciones",
  "address": "Dirección",
  "state": "Estado",
  "zip-code": "Código Postal",
  "kind": "Tipo",
  "phone-number": "Número Telefónico",
  "licenses": "Licencias",
  "member-of": "Miembro De",
  "members": "Miembros",
  "name": "Nombre",
  "see-party": "Ver Contacto",
  "users": "Usuarios",
  "login": "Login",
  "personal": "Personal",
  "work": "Trabajo",
  "create-user": "Crear Usuario",
  "edit-user": "Editar Usuario",
  "create-user-success": "Usuario creado con éxito",
  "create-user-error": "Ocurrió un error en la creción del usuario",
  "invite-warning": "Si desea invitar a este usuario al sistema, ingrese una dirección de correo electrónico a continuación.",
  "invite-success": "La invitación fue entregada con éxito.",
  "invite-error": "La invitación no tuvo éxito, puedes volver a intentarlo más tarde.",
  "no-addresses": "No hay direcciones anteriores, puedes crear una nueva aquí",
  "no-emails": "No hay emails anteriores, puedes crear una nueva aquí",
  "no-phones": "No hay teléfonos anteriores, puedes crear una nueva aquí",
  "no-licenses": "No hay licencias anteriores, puedes crear una nueva aquí",
  "no-parties": "No hay partes vinculadas a este usuario",
  "no-members": "No hay miebros vinculados a este usuario",
  "no-payments": "No hay pagos anteriores, puedes crear uno nuevo aquí",
  "create-address": "Crear dirección",
  "create-email": "Crear email",
  "create-phone": "Crear teléfono",
  "create-license": "Crear licencia",
  "create-party": "Crear Parte",
  "create-payment": "Crear Pago",
  "create": "Crear",
  "add-new": "Agregar Nuevo",
  "contacts": "Contactos",
  "create-new": "Puedes crear un nuevo contacto si no se encuentra el que buscas",
  "search-parties-orgs": "Buscar partes existentes u Organizaciones",
  "placeholder-search-parties-orgs": "Buscar Organizaciones / Partes",
  "create-com": "Crear una compañia",
  "create-org": "Crear una organización",
  "create-com-label": "Crear compañias para vincular usuarios",
  "create-party-label": "Invitar a una nueva parte",
  "create-org-label": "Crear una organización",
  "user-system": "Usuario del sistema",
  "phones": "Teléfonos",
  "no-matching-data": "Sin coincidencias",
  "user-is-going-to-be-invited": "El usuario será invitado al sistema desde esta dirección de correo electrónico",
  "person": "Persona",
  "company": "Compañia",
  "organization": "Organización",
  "invite": "Invitar",
  "orders": "Ordenes",
  "parties": "Partes",
  "configuration": "Configuración",
  "receive-all-notifications": "Recibir todas las notificaciones",
  "unlink": "Desvincular",
  "error-unlinking-user": "Error al desvincular usuario",
  "error-deleting-user": "Error borrando usuario",
  "create-order-only-title-employee": "Póngase en contacto con un administrador para poder crear nuevas ordenes",
  "dialog-confirm-label": "Escribe ${} para confirmar",
  "dialog-unlink-title": "¿Desea desvincular al siguiente usuario de la plataforma de títulos?",
  "dialog-unlink-description": "Si desvincula a este usuario de la plataforma, el usuario no podrá volver a acceder a ella, a menos que se le conceda acceso de nuevo manualmente.",
  "dialog-unlink-confirm-button": "Desvincular usuario de la plataforma",
  "dialog-delete-title": "¿Estás seguro de que quieres eliminar este usuario?",
  "dialog-delete-description": "Una vez que elimines esta cuenta, no podrás recuperarla. Asegúrate de querer hacer esto.",
  "dialog-delete-confirm-button": "Eliminar usuario de la plataforma",
  "payments": "Pagos",
  "account": "Cuenta",
  "partyId": "Partida ID",
  "routing": "Enrutamiento",
  "reference": "Referencia",
  "order-transfer": "Transferencia de orden",
  "for_benefit_of": "En beneficio de",
  "country": "País",
  "bank": "Banco",
  "bank-address": "Dirección del Banco",
  "sorry": "Disculpe",
  "you-dont-have-access": "No tienes acceso a esta pantalla",
  "contact-to-the-admin": "Contacta con el Administrador para obtener más información",
  "referencias": "Referencias",
  "locality": "Localidad",
  "settlement": "Asentamiento",
  "user-linked-success": "El usuario fue vinculado con éxito",
  "user-unlinked-success": "El usuario fue desvinculado exitosamente",
  "wire-transfers": "Transferencias bancarias",
  "create-contact":"Crear Contacto",
  "removeMemberTitle": "Eliminar Miembro",
  "removeMemberConfirmation": "¿Está seguro de que desea eliminar el miembro?",
  "removeButton": "Eliminar",
  "newInfoAvailableMessage": "Nueva información disponible, ¿desea recargar?",
  "reloadButton": "Recargar",
  "createButton": "Crear",
  "addNewButton": "Agregar Nuevo",
  "deleteWireTransferTitle": "Eliminar Transferencia Bancaria",
  "deleteWireTransferConfirmation": "¿Está seguro de que desea eliminar la transferencia bancaria?",
  "ssn-atin-itin-ptin": "SSN/ATIN/ITIN/PTIN",
  "ein": "EIN",
  "password-recovery-title": "Enviar instrucciones de recuperación de contraseña",
  "password-recovery-description": "Las instrucciones se enviarán a {{email}} al hacer clic en Enviar. No se realizarán cambios hasta que el destinatario siga los pasos descritos en ese correo electrónico.",
  "password-recovery-send": "Enviar"
}
